import { render, staticRenderFns } from "./AutomaticSelector.vue?vue&type=template&id=b787c6aa&"
import script from "./AutomaticSelector.vue?vue&type=script&lang=js&"
export * from "./AutomaticSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports